<template>
  <div>
    <div>
      <div>
        <div class="w-full">
          <h3 class="text-4f4f4f text-xl font-semibold mb-0">
            Product Attributes
          </h3>
          <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
            Mix and match attributes and create different variations of this
            product with pricing.<br />
            The first attribute selected will be the primary attribute.
          </p>
        </div>
      </div>

      <div class="mt-12">
        <div class="flex justify-between">
          <div>
            <h3 class="text-4f4f4f text-xl mb-0 font-semibold">
              {{ attrName.attributesId[0].name }}
            </h3>
            <!-- <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
              Edit photos to showcase your offerings
            </p> -->
            <el-input
              placeholder="Enter or Type Attributes value..."
              v-model="attributeVal"
              disabled
              class="rounded-xl mt-2"
            />
          </div>
          <div>
            <feather-icon
              @click="deletePopup(productDetail._id)"
              icon="Trash2Icon"
              svgClasses="w-6 h-6"
              class="text-8f8f8f cursor-pointer"
            />
            <!-- <p
              @click="openPop()"
              class="fill-chips rounded-lg fsize12 bg-primary text-white px-8 cursor-pointer py-2"
            >
              Add
            </p> -->
          </div>
        </div>
        <div class="mt-8">
          <!-- <div class="flex justify-between">
            <h3 class="text-4f4f4f text-lg mb-0">
              {{ productDetail.valueName }}
              {{ attrName.attributesId[0].name }}
              <el-input
                placeholder="Enter or Type Attributes value..."
                v-model="attributeVal"
                class="rounded-xl mt-2"
              />
            </h3>
          </div> -->
          <!-- <div
            v-for="(color, index) in productDetail.productImageId"
            :key="`${color}+${index}`"
          > -->
          <!-- <div class="grid grid-cols-5 gap-6 mt-4">
            <div
              class="bg-f4f5f6 rounded-10px relative h-100px flex justify-center items-center relative"
              v-for="(colorIMG, index) in productDetail.productImage"
              :key="`${colorIMG}+${index}`"
            >
              <img
                :src="getUrl(colorIMG)"
                class="rounded-4px object-cover w-full imgpre h-75px"
              />
            </div>
          </div> -->
          <el-upload
            v-if="datavalue.length == 0"
            class="upload-demo mt-1 category-uploader"
            multiple
            action="#"
            drag
            :before-upload="multipleimages"
            accept="image/*"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div> -->
          </el-upload>
          <!-- </div> -->
          <div class="mt-6 grid grid-cols-4 gap-2">
            <div
              v-for="(image, index) in renderedmultipleImage"
              :draggable="true"
              @dragstart="handleDragStart(index, $event)"
              @dragover="handleDragOver(index, $event)"
              @drop="handleDrop(index)"
              class="relative draggable-item"
              :key="`${image} + ${index}`"
            >
              <img
                :src="image"
                class="rounded-4px object-cover w-full imgpre h-75px"
              />

              <div
                class="absolute top-0 xiconset right-0 bg-white rounded-full p-1"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer flex"
                  @click="
                    () => {
                      datavalue.splice(index, 1);
                      renderedmultipleImage.splice(index, 1);
                    }
                  "
                />
              </div>
            </div>
            <!-- </div> -->
            <el-upload
              v-if="datavalue.length < 10 && datavalue.length > 0"
              class="upload-demo mt-1 vi-up custuploadht"
              multiple
              action="/invalid-url"
              drag
              :before-upload="multipleimages"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 mt-8">
        <vs-button
          type="primary"
          class="bg-primary rounded-lg font-semibold py-5 fsize14"
          @click="saveAttributeVal"
          >Save</vs-button
        >

        <vs-button
          type="secondary"
          class="bg-secondary rounded-lg font-semibold py-5 fsize14"
          @click="closePopup"
          >Cancel</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import addAttributeVal from "./addAttributeVal";
export default {
  props: {
    productDetail: {
      type: Object,
    },
    EditAttribuitesValShow: {
      type: Boolean,
    },
    attrName: {
      type: Object,
    },
  },
  components: {
    addAttributeVal,
  },
  data() {
    return {
      activeNames: "1",
      AddColor: false,
      value1: [],
      value2: [],
      Attribute2: [],
      primaryAttribute: null,
      secondaryAttribute: null,
      // productDetail: {},
      attribute1: "",
      attribute2: "",
      attributeVal: "",
      datavalue: [],
      renderedmultipleImage: [],
      attributessizeOptions: [
        {
          value: "XL",
          label: "XL",
        },
        {
          value: "LG",
          label: "LG",
        },
      ],
      counter: 1,
      draggedIndex: null,
    };
  },
  watch: {
    EditAttribuitesValShow(val) {
      if (val === true) {
        this.attributeVal = this.productDetail.valueName;
        this.init();
      } else {
        this.attributeVal = "";
        this.reset();
      }
    },
  },
  methods: {
    handleDragStart(index, event) {
      this.draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", index);
    },
    handleDragOver(index, event) {
      event.preventDefault();
    },
    handleDrop(index) {
      const draggedImage = this.renderedmultipleImage[this.draggedIndex];
      this.renderedmultipleImage.splice(this.draggedIndex, 1);
      this.renderedmultipleImage.splice(index, 0, draggedImage);

      const draggedImageData = this.datavalue[this.draggedIndex];
      this.datavalue.splice(this.draggedIndex, 1);
      this.datavalue.splice(index, 0, draggedImageData);
    },
    handleDragEnd() {
      this.draggedIndex = null;
    },
    reset() {
      this.datavalue = [];
      this.counter = 1;
      this.renderedmultipleImage = [];
      this.attributeVal = "";
      this.draggedIndex = null;
    },
    async deletePopup(id) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.handleDelete(id);
        }
      });
    },
    async handleDelete(id) {
      console.log(id);
      let payload = {
        productImageId: id,
        adminId: this.login._id,
      };
      try {
        let data = await this.$store.dispatch(
          "EcomProduct/deleteProductImage",
          payload
        );
        if (data.code === 200) {
          await this.$store.dispatch("EcomProduct/getAllProduct");
          this.closePopup();
          await this.$swal("Deleted", "Successfully deleted", "success");
          // this.reset();
        }
      } catch (error) {
        console.log(error);
        await this.$swal("Delete", "Failed to Delete", "error");
      }
    },
    async init() {
      this.reset();
      this.attributeVal = this.productDetail.valueName;
      let imagesData = this.productDetail.productImage.map(
        async (img, index) => {
          let imageFile = await this.getImageMetadata(this.getUrl(img));
          // console.log(imageFile);
          this.newHandlemultiple(imageFile);
          return imageFile;
        }
      );

      let rawData = await Promise.all(imagesData);

      this.datavalue = this.productDetail.productImage ? rawData : [];
      // console.log(this.datavalue);
      // console.log(this.renderedmultipleImage);
    },
    async multipleimages(file) {
      // console.log(file.target.files,"khk");
      // console.log(file);
      // console.log(this.datavalue);
      if (this.datavalue.length < 10) {
        this.datavalue.push(file);
      } else {
        // this.datavalue.shift(file);
        return await this.$swal({
          title: `Only 10 Images are Allowed!`,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
      console.log(this.datavalue.length);
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < 10) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
          // console.log(this.renderedmultipleImage);
        } else {
          // this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };
      reader.readAsDataURL(rawFile);
    },
    async getImageMetadata(imageUrl) {
      let raw = await fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          // console.log(blob);
          // console.log(imageUrl);
          const file = new File([blob], "image", { type: blob.type });
          return file;
        })
        .catch((error) => {
          console.error("Error fetching the image:", error);
        });
      // console.log(raw);
      return raw;
    },
    // getImageMetadata(imageUrl) {
    //   fetch(imageUrl)
    //     .then((response) => response.blob())
    //     .then((blob) => {
    //       convertBlobToImage(blob);
    //       const reader = new FileReader();
    //       reader.onloadend = function () {
    //         const arrayBuffer = reader.result;
    //         const dataView = new DataView(arrayBuffer);
    //         //const metadata = extractImageMetadata(dataView);
    //         console.log(blob);
    //       };
    //       reader.readAsArrayBuffer(blob);
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching the image:", error);
    //     });
    // },
    // convertBlobToImage(blob) {
    //   const img = document.createElement("img");
    //   img.src = URL.createObjectURL(blob);
    //   console.log(img);
    //   // Append the image to the DOM or use it as needed
    //   document.getElementById("allMetaDataSpan").appendChild(img);
    // },

    // async openPop() {
    //   this.AddColor = true;
    //   this.$emit("closePopup");
    //   let payload1 = {
    //     attributeName: this.primaryAttribute,
    //   };
    //   await this.$store.dispatch(
    //     "EcomAttributes/getSingleAttributesPrim",
    //     payload1
    //   );
    // },
    // async addAttributeValuePrimary() {
    //   let payload = {
    //     attributeValue: this.attributeVal,
    //     attributeName: this.singleAttrinutesPrime.name,
    //   };
    //   console.log(singleAttrinutesPrime);
    //   console.log(payload);
    //   await this.$store.dispatch("EcomAttributes/editAttributesValue", payload);
    // },
    // async multipleimages(file) {
    //   // console.log(file.target.files,"khk");
    //   console.log(file);
    //   console.log(this.datavalue);
    //   if (this.datavalue.length < 5) {
    //     this.datavalue.push(file);
    //   } else {
    //     this.datavalue.shift(file);
    //   }
    //   this.newHandlemultiple(file);
    // },
    // async newHandlemultiple(rawFile) {
    //   const reader = new FileReader();
    //   reader.onload = (e) => {
    //     if (this.renderedmultipleImage.length < 5) {
    //       this.$emit("load", this.renderedmultipleImage.push(e.target.result));
    //     } else {
    //       this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
    //     }
    //   };

    //   reader.readAsDataURL(rawFile);
    // },
    async readFile(file) {
      let self = this;
      let result = await new Promise((resolve) => {
        if (file) {
          let reader = new FileReader();
          let fileName = file.name.split(".");
          reader.onload = async function (event) {
            var renamedFile = new File(
              [event.target.result],
              `${self.counter}.${fileName[fileName.length - 1]}`,
              { type: file.type }
            );
            // renameFiles.push(renamedFile);
            // payload.append("productImage", renamedFile);
            // console.log(self.counter);
            self.counter++;
            resolve(renamedFile);
            // console.log(renamedFile);
          };
          reader.readAsArrayBuffer(file);
        }
      });
      return result;
    },
    async saveAttributeVal() {
      if (this.datavalue && this.datavalue.length <= 0) {
        return await this.$swal({
          title: `Please upload Images!`,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#cd3197",
        });
      }
      const payload = new FormData();
      payload.append("valueName", this.attributeVal);
      payload.append("productId", this.onClickProduct._id);
      payload.append("productImageId", this.productDetail._id);
      // for (let i in this.datavalue) {
      //   // console.log(this.datavalue[i]);
      //   payload.append("productImage", this.datavalue[i]);
      // }
      for (let i in this.datavalue) {
        // payload.append("productImage", this.datavalue[i]);
        // console.log(this.datavalue[i].name);
        let file = this.datavalue[i];
        let data = await this.readFile(file);
        // console.log(data);
        payload.append("productImage", data);
        // console.log(this.datavalue[i].name);
      }
      // console.log(this.datavalue);

      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let data = await this.$store.dispatch(
          "EcomProduct/editProductImage",
          payload
        );
        if (data.code === 200) {
          await this.$store.dispatch("EcomProduct/getAllProduct");
          loader.close();
          this.closePopup();
          await this.$swal({
            title: `Product Attribute Updated Successfully!`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.reset();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
        await this.$swal({
          title: `Failed to Update the Product Attribute!`,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
    },
    closePopup() {
      this.reset();
      this.$emit("closePopup");
    },
    getUrl(img) {
      // console.log(`${this.$imageUrl}/${img}`);
      // console.log(this.$imageUrl);
      return `${this.$imageUrl ? this.$imageUrl : this.$imageURL}${img}`;
    },
    // async addAttributePrm() {
    //   let payload = {
    //     name: this.primaryAttribute,
    //     // productId: this.$store.state.EcomAttributes.onClickProduct._id,
    //     productId: this.onClickProduct._id,
    //   };
    //   await this.$store.dispatch("EcomAttributes/addAttributes", payload);
    // },
    // async addAttributeSec() {
    //   let payload = {
    //     name: this.secondaryAttribute,
    //     // productId: this.$store.state.EcomAttributes.onClickProduct._id,
    //     productId: this.onClickProduct._id,
    //   };
    //   await this.$store.dispatch("EcomAttributes/addAttributes", payload);
    // },
  },
  computed: {
    ...mapState("EcomAttributes", [
      "EcomAttrinutes",
      "singleAttrinutesPrime",
      "singleAttrinutesSec",
      "onClickProduct",
    ]),
    ...mapState("admin", ["login"]),
    // imageURL() {
    //   return `${this.$imageURL}/`;
    //   // return "https://nimbuscluster.blob.core.windows.net/server01/";
    // },
  },
  mounted() {
    this.init();
    // console.log(this.productDetail);
  },
};
</script>
<style>
.custuploadht .el-upload-dragger {
  height: 75px;
}
.custuploadht .el-upload-dragger .el-icon-upload {
  line-height: 0px !important;
  font-size: 50px !important;
}
</style>
